import * as React from 'react'
import { motion } from 'motion/react'

import cn from '@config/tailwind/cn'

import type { CardAction } from './card-action'

export type BookCollectionCardSize = 'large' | 'small'

/** Shared dimensions for BookCollectionCard. */
export const bookCollectionCardSizeStyles: Record<
  BookCollectionCardSize,
  { wrapper: string; img: { width: number; height: number } }
> = {
  large: { wrapper: 'srd:w-[256px] srd:h-[192px]', img: { width: 256, height: 192 } },
  small: { wrapper: 'srd:w-[171px] srd:h-[128px]', img: { width: 171, height: 128 } },
}

interface BookCollectionCardProps {
  id: string
  coverUrl: string
  action: CardAction
  size?: BookCollectionCardSize
  className?: string
}

export function BookCollectionCard({ id, coverUrl, action, size = 'large', className }: BookCollectionCardProps) {
  const { wrapper, img } = bookCollectionCardSizeStyles[size]

  const content = (
    <motion.div
      data-id={id}
      whileHover={{ scale: 1.025 }}
      whileTap={{ scale: 0.975 }}
      className={cn('srd:cursor-pointer', wrapper, className)}
    >
      <div className='srd:rounded-2xl srd:overflow-hidden srd:w-full srd:h-full'>
        <img
          src={coverUrl}
          alt=''
          width={img.width}
          height={img.height}
          draggable={false}
          loading='lazy'
          decoding='async'
          className='srd:w-full srd:h-full srd:object-cover'
        />
      </div>
    </motion.div>
  )

  if (action.type === 'link') return action.renderWrapper(content)
  return (
    <button type='button' onClick={action.onClick} className='srd:block'>
      {content}
    </button>
  )
}
